import React from "react";
import Typography from "@material-ui/core/Typography";
import FraudStatusIcon from "./FraudStatusIcon";
import { formatDate } from "app/utils/filters";

import { graphql } from "react-apollo";
import { susDeviceCommentsQuery } from "./DeviceFraudCommentsQuery";

const Comments = ({ comments }) => (
  <ul>
    {(comments || [])
      .slice()
      .reverse()
      .map((comment, i) => (
        <li key={i}>
          {formatDate(comment.updated_at)}{" "}
          <FraudStatusIcon fraudStatus={comment.status} />{" "}
          {comment.comment || " - "} <i>{comment.user}</i>
        </li>
      ))}
  </ul>
);

export const deviceFraudCommentsSimple = ({ device }) => {
  const data = { data: { devices: [device] } };
  return deviceFraudComments(data);
};

const deviceFraudComments = ({ data }: { data: any }) => {
  const { devices } = data;

  const device = devices && devices[0];
  if (!device)
    return (
      <Typography>
        <p>fetching...</p>
      </Typography>
    );

  return (
    <Typography>
      <div>
        Token: {device.token}&nbsp;
        <FraudStatusIcon fraudStatus={device.suspicious_token_status} />
        <Comments comments={device.suspicious_token_comments} />
      </div>
      <div>
        Phone number: {device.phone_number}&nbsp;
        <FraudStatusIcon fraudStatus={device.suspicious_phone_number_status} />
        <Comments comments={device.suspicious_phone_number_comments} />
      </div>
    </Typography>
  );
};

const deviceFraudCommentsWithGraphql = graphql(susDeviceCommentsQuery, {
  skip: (props: any) => !props || !props.deviceExternalReference,
  options(props: any) {
    return {
      variables: {
        deviceExternalReference: props.deviceExternalReference,
      },
    };
  },
})(deviceFraudComments);

export default deviceFraudCommentsWithGraphql;
